export default __webpack_public_path__ + "static/media/onewithdeath.a87f36bf.png";